<template>
  <div class="transformation">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">Digital Transformation</h3>
        <p>RPA(Robotic Process Automation)</p>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          <div class="transformation-graph">
            <ul>
              <li v-for="(item, i) in items" :key="i">
                <v-img contain :src="item.src" max-height="60"></v-img>
                <span v-html="item.text"></span>
              </li>
            </ul>
          </div>
          <dl class="mt-6 mt-md-12 text-center">
            <dt class="text-h6 text-md-h5 font-weight-bold mb-2">RPA(Robotic Process Automation)</dt>
            <dd class="px-4">사람이 컴퓨터로 처리하는 "반복적", "규칙적", "대량의" 작업을 자동으로 처리하는 "소프트웨어"</dd>
          </dl>
        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'transformation',
  data() {
    return {
      items: [
        {
          src: require("@/assets/img_sub_ser_transformation_01.svg"),
          text: "유형의 기계장치가 아닌,<br>무형의 소프트웨어",
        },
        {
          src: require("@/assets/img_sub_ser_transformation_02.svg"),
          text: "UI (User Interface)<br>Layer에 작동",
        },
        {
          src: require("@/assets/img_sub_ser_transformation_03.svg"),
          text: "비즈니스 어플리케이션<br>사용에 제약 없음",
        },
        {
          src: require("@/assets/img_sub_ser_transformation_04.svg"),
          text: "기존IT인프라에 신속,<br>간단하게 설치",
        },
        {
          src: require("@/assets/img_sub_ser_transformation_05.svg"),
          text: "24시간 업무 수행,<br>사람보다 빠르게 Task 처리",
        },
        {
          src: require("@/assets/img_sub_ser_transformation_06.svg"),
          text: "업무 실수 및 누락 미 발생,<br>사람의 의도 개입 제거",
        },
        {
          src: require("@/assets/img_sub_ser_transformation_07.svg"),
          text: "사람은 전략적 업무에 집중<br>52시간 준수",
        },
      ],
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".transformation .sub-body-title", {
      scrollTrigger: {
        trigger: ".transformation .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".transformation-graph li", {
      scrollTrigger: {
        trigger: ".transformation-graph li",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .1,
    });
    gsap.from(".transformation-graph + dl", {
      scrollTrigger: {
        trigger: ".transformation-graph + dl",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .1,
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>